import { useCallback } from 'react';
import format from 'string-template';

/**
 * Shared handlers used by screens that manage message text + attachments.
 */
const useAttachmentInputHandlers = ({
  showToast,
  fileSizeErrorText,
  maxFileSizeBytes,
  maxFileSizeMb,
  placeholderCopiedText,
}) => {
  const onFilesSelected = useCallback((event, setAttachments) => {
    const { files } = event.target;
    if (files.length) {
      const filesArray = [...files];
      const validFiles = filesArray.every((file) => file.size < maxFileSizeBytes);
      if (validFiles) {
        const formattedFiles = filesArray.map((file) => {
          const lastDotIndex = file.name.lastIndexOf('.');
          return {
            dataUrl: URL.createObjectURL(file),
            format: file.name.slice(lastDotIndex + 1),
            fileName: file.name.slice(0, lastDotIndex),
            fileType: file.type,
            name: file.name,
            isUploaded: false,
          };
        });
        setAttachments((prev) => [...prev, ...formattedFiles]);
      } else {
        showToast(
          format(fileSizeErrorText, {
            maxFileSize: maxFileSizeMb,
          }),
          { error: true },
        );
      }
    }
  }, [fileSizeErrorText, maxFileSizeBytes, maxFileSizeMb, showToast]);

  const removeFileByIndex = useCallback((index, setAttachments) => {
    setAttachments((prev) => {
      const next = [...prev];
      next.splice(index, 1);
      return next;
    });
  }, []);

  const copyPlaceholderValue = useCallback(async (placeholderValue) => {
    await navigator.clipboard.writeText(`{${placeholderValue}}`);
    showToast(placeholderCopiedText);
  }, [placeholderCopiedText, showToast]);

  return {
    onFilesSelected,
    removeFileByIndex,
    copyPlaceholderValue,
  };
};

export default useAttachmentInputHandlers;
